export class IStaticReport {
  preview: boolean = true;
  dateInit: string = "";
  dateEnd: string = "";
}